import LS from './localstorage'
import Product from '@/model/product/product'
const ls = new LS()

export const order = (products: Product[], router: any) => {
  console.log(products, 'ts')
  ls.set('products', products)
  if (router) {
    window.location.href =
      'https://www.youkeda.com/home_m/cart?_t=' + new Date().getTime()
  }
}
//'http://dev.youkeda.com:1024/home_m/cart?_t=' + new Date().getTime()
// 'https://www.youkeda.com/home_m/cart?_t=' + new Date().getTime()
